<template>
    <div>
        <Breadcrumbs main="Admin" submain="" title="বিশ্লেষণ (Analytics)" />
        
        <!-- Container-fluid starts-->
        <div class="container-fluid mt-4" v-if="role === 'admin'">
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div style="width: 100%;">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5 style="font-weight: 700;">অভিযোগের পরিসংখ্যান</h5>
                                        <div class="row mt-2 mt-4">
                                            <div class="col-md-3">
                                                <h7>পরিসর</h7>
                                                <b-form-select v-model="range" :options="formattedRanges" placeholder="Select a Range"></b-form-select>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <h7>শুরুর তারিখ</h7>
                                                    <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <div>
                                                    <h7>শেষ তারিখ</h7>
                                                    <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <h7>অভিযোগের ধরণ</h7>
                                                <b-form-select v-model="category" :options="formattedCategories" placeholder="Select a Category"></b-form-select>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-4 mt-3 mt-md-0">
                                                <h7>অঞ্চল</h7>
                                                <b-form-select v-model="onchol" :options="formattedOnchols" @change="onOncholChange" placeholder="Select a Ward"></b-form-select>
                                            </div>
                                            <div class="col-md-4 mt-3 mt-md-0">
                                                <h7>ওয়ার্ড নং</h7>
                                                <b-form-select v-model="ward_no" :options="formattedWards" placeholder="Select a Ward"></b-form-select>
                                            </div>
                                            <div class="col-md-4">
                                                <div style="margin-top: 21px; display: flex; gap: 12px; align-items: center; justify-content: center; color: white; background-color: #DC3545; padding: 7px 14px; min-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()">
                                                    <feather type="x"></feather>
                                                    <h7>Clear Filter</h7>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-4">
                                        <div>
                                            <div id="chart-container">
                                                <apexchart height="450" :options="chartOptions" :series="series"></apexchart>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" style="margin-top: 100px;">
                                    <div class="col-md-12">
                                        <h5 style="font-weight: 700;">অভিযোগের ধরণভেদে পরিসংখ্যান</h5>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                <div>
                                                    <h7>শুরুর তারিখ</h7>
                                                    <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_dateTwo"></datepicker>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <div>
                                                    <h7>শেষ তারিখ</h7>
                                                    <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_dateTwo"></datepicker>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <h7>অভিযোগের ধরণ</h7>
                                                <b-form-select v-model="categoryTwo" :options="formattedCategories" placeholder="Select a Category"></b-form-select>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <h7>অঞ্চল</h7>
                                                <b-form-select v-model="oncholTwo" :options="formattedOncholsTwo" @change="onOncholChangeTwo" placeholder="Select a Ward"></b-form-select>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <h7>ওয়ার্ড নং</h7>
                                                <b-form-select v-model="ward_noTwo" :options="formattedWardsTwo" placeholder="Select a Ward"></b-form-select>
                                            </div>
                                            <div class="col-md-2">
                                                <div style="margin-top: 21px; display: flex; gap: 12px; align-items: center; justify-content: center; color: white; background-color: #DC3545; padding: 7px 14px; min-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilterTow()">
                                                    <feather type="x"></feather>
                                                    <h7>Clear Filter</h7>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-4">
                                        <div>
                                            <div id="chart-container">
                                                <apexchart type="bar" height="450" :options="chartOptionsForCategory" :series="seriesForCategory"></apexchart>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" style="margin-top: 100px;">
                                    <div class="col-md-12">
                                        <h5 style="font-weight: 700;">অঞ্চলভেদে অভিযোগ পরিসংখ্যান</h5>
                                        <div class="row mt-4">
                                            <div class="col-md-3">
                                                <div>
                                                    <h7>শুরুর তারিখ</h7>
                                                    <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_dateThree"></datepicker>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <div>
                                                    <h7>শেষ তারিখ</h7>
                                                    <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_dateThree"></datepicker>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <div>
                                                    <h7>অভিযোগের ধরণ</h7>
                                                    <b-form-select v-model="categoryThree" :options="formattedCategories" placeholder="Select a Category"></b-form-select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div style="margin-top: 21px; display: flex; gap: 12px; align-items: center; justify-content: center; color: white; background-color: #DC3545; padding: 7px 14px; min-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilterThree()">
                                                    <feather type="x"></feather>
                                                    <h7>Clear Filter</h7>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <div id="chart-container">
                                                <apexchart type="bar" height="450" :options="chartOptionsForOnchol" :series="seriesForOnchol"></apexchart>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" style="margin-top: 100px;">
                                    <div class="col-md-12">
                                        <h5 style="font-weight: 700;">ওয়ার্ডভেদে অভিযোগ পরিসংখ্যান</h5>
                                        <div class="row mt-4">
                                            <div class="col-md-3">
                                                <div>
                                                    <h7>শুরুর তারিখ</h7>
                                                    <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_dateFour"></datepicker>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <div>
                                                    <h7>শেষ তারিখ</h7>
                                                    <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_dateFour"></datepicker>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-3 mt-md-0">
                                                <div>
                                                    <h7>অভিযোগের ধরণ</h7>
                                                    <b-form-select v-model="categoryFour" :options="formattedCategories" placeholder="Select a Category"></b-form-select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div style="margin-top: 21px; display: flex; gap: 12px; align-items: center; justify-content: center; color: white; background-color: #DC3545; padding: 7px 14px; min-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilterFour()">
                                                    <feather type="x"></feather>
                                                    <h7>Clear Filter</h7>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <div id="chart-container">
                                                <apexchart type="bar" height="450" :options="chartOptionsForWard" :series="seriesForWard"></apexchart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div v-else>
                                <loader />
                            </div> -->
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <div class="container-fluid mt-4" v-else>
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div style="height: calc(100vh - 200px); text-align: center; padding: 80px 20px;">
                            <h5>Welcome to Fair Dhaka Admin Dashboard</h5>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import loader from '../loader/loader.vue';
import moment from "moment";

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect,
        loader
    },

    data() {
        return {
            role: '',
            onchol: null,
            ward_no: null,
            category: null,
            range: 'week',
            start_date: null,
            end_date: null,
            oncholTwo: null,
            ward_noTwo: null,
            categoryTwo: null,
            start_dateTwo: null,
            end_dateTwo: null,
            start_dateThree: null,
            end_dateThree: null,
            categoryThree: null,
            start_dateFour: null,
            end_dateFour: null,
            categoryFour: null,
            ranges: [
                { value: 'year', text: 'Yearly' },
                { value: 'month', text: 'Monthly' },
                { value: 'week', text: 'Weekly' },
            ],
            categories: [
                { value: "road", title: "রাস্তা (Road)" },
                { value: "mosquito", title: "মশা (Mosquito)" },
                { value: "garbage", title: "বর্জ্য (Waste)" },
                { value: "street_light", title: "রাস্তার বাতি (Street Light)" },
                { value: "public_toilet", title: "পাবলিক টয়লেট (Public Toilet)" },
                { value: "drainage", title: "নিষ্কাশন ব্যবস্থা (Drainage)" },
                { value: "illegal_structure", title: "অবৈধ কাঠামো (Illegal Structure)" },
                { value: "waterlog", title: "জলাবদ্ধতা (Waterlog)" },
                { value: "air_pollution", title: "বায়ু দূষণ (Air Pollution)" },
                { value: "noise_pollution", title: "শব্দ দূষণ (Noise Pollution)" },
            ],
            chartOptions: {
                chart: {
                    height: 100,
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    categories: []
                }
            },
            series: [],
            chartOptionsForCategory: {
                chart: {
                    height: 100,
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    categories: []
                }
            },
            seriesForCategory: [],
            chartOptionsForOnchol: {
                chart: {
                    height: 100,
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    categories: []
                }
            },
            seriesForOnchol: [],
            chartOptionsForWard: {
                chart: {
                    height: 100,
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    categories: []
                }
            },
            seriesForWard: [],
        }
    },

    computed: {
        ...mapState({
            wards: state => state.issue.wards,
            onchols: state => state.issue.onchols,
            complaint_graph: state => state.issue.complaint_graph,
            complain_by_category_graph: state => state.issue.complain_by_category_graph,
            complain_by_onchol_graph: state => state.issue.complain_by_onchol_graph,
            complain_by_ward_graph: state => state.issue.complain_by_ward_graph,
            loading: state => state.dashboard.dashboardCountLoading,
            error: state => state.dashboard.dashboardCountError,
        }),

        formattedCategories() {
            return this.categories.map(category => {
                return {
                    value: category.value,
                    text: category.title
                };
            });
        },

        formattedRanges() {
            return this.ranges.map(range => {
                return {
                    value: range.value,
                    text: range.text
                };
            });
        },

        formattedWards() {
            return this.wards.map(ward => {
                return {
                    value: ward?.id,
                    text: `${ward?.bangla_name} (${ward?.name})`
                };
            });
        },
        
        formattedOnchols() {
            return this.onchols.map(onchol => {
                return {
                    value: onchol?.id,
                    text: `${onchol?.bangla_name} (${onchol?.name})`
                };
            });
        },

        formattedWardsTwo() {
            return this.wards.map(ward => {
                return {
                    value: ward?.id,
                    text: `${ward?.bangla_name} (${ward?.name})`
                };
            });
        },
        
        formattedOncholsTwo() {
            return this.onchols.map(onchol => {
                return {
                    value: onchol?.id,
                    text: `${onchol?.bangla_name} (${onchol?.name})`
                };
            });
        }
    },

    watch: {
        complaint_graph(newValue, oldValue) {},
        complain_by_category_graph(newValue, oldValue) {},
        complain_by_onchol_graph(newValue, oldValue) {},
        complain_by_ward_graph(newValue, oldValue) {},

        onchol() {
            this.fetchComplaint();
        },
        category() {
            this.fetchComplaint();
        },
        ward_no() {
            this.fetchComplaint();
        },
        range(newVal) {
            this.setDateRange(newVal);
            this.fetchComplaint();
        },
        start_date() {
            this.fetchComplaint();
        },
        end_date() {
            this.fetchComplaint();
        },
        oncholTwo() {
            this.fetchComplaintByCategory();
        },
        ward_noTwo() {
            this.fetchComplaintByCategory();
        },
        start_dateTwo() {
            this.fetchComplaintByCategory();
        },
        end_dateTwo() {
            this.fetchComplaintByCategory();
        },
        categoryTwo() {
            this.fetchComplaintByCategory();
        },
        start_dateThree() {
            this.chartOptionsForOncholGraph();
        },
        end_dateThree() {
            this.chartOptionsForOncholGraph();
        },
        categoryThree() {
            this.chartOptionsForOncholGraph();
        },
        start_dateFour() {
            this.chartOptionsForWardGraph();
        },
        end_dateFour() {
            this.chartOptionsForWardGraph();
        },
        categoryFour() {
            this.chartOptionsForWardGraph();
        }
    },

    created() {
        this.setDateRange(this.range);

        // const end = new Date();
        // const start = new Date();
        // start.setDate(end.getDate() - 6);

        // this.end_date = moment(end).format("YYYY-MM-DD");
        // this.start_date = moment(start).format("YYYY-MM-DD");
        // this.end_dateTwo = moment(end).format("YYYY-MM-DD");
        // this.start_dateTwo = moment(start).format("YYYY-MM-DD");
        // this.end_dateThree = moment(end).format("YYYY-MM-DD");
        // this.start_dateThree = moment(start).format("YYYY-MM-DD");
        // this.end_dateFour = moment(end).format("YYYY-MM-DD");
        // this.start_dateFour = moment(start).format("YYYY-MM-DD");
    },

    mounted() {
        this.role = localStorage.getItem("role");
        this.$store.dispatch('issue/getWards')
        this.$store.dispatch('issue/getOnchols')
        this.fetchComplaint();
        this.fetchComplaintByCategory();
        this.chartOptionsForOncholGraph();
        this.chartOptionsForWardGraph();
    },

    methods: {
        setDateRange(range) {
            const today = moment();

            if (range === "week") {
                this.start_date = today.clone().startOf("week").format("YYYY-MM-DD");
                this.end_date = today.clone().endOf("week").format("YYYY-MM-DD");
            } 
            else if (range === "month") {
                this.start_date = today.clone().startOf("month").format("YYYY-MM-DD");
                this.end_date = today.clone().endOf("month").format("YYYY-MM-DD");
            } 
            else if (range === "year") {
                this.start_date = today.clone().startOf("year").format("YYYY-MM-DD");
                this.end_date = today.clone().endOf("year").format("YYYY-MM-DD");
            }
        },

        onOncholChange() {
            this.$store.dispatch('issue/getWardsByOnchol', this.onchol)
        },

        onOncholChangeTwo() {
            this.$store.dispatch('issue/getWardsByOnchol', this.oncholTwo)
        },

        fetchComplaint() {
            this.$store.dispatch("issue/fetchComplaintGraph", {
                ward_no: this.ward_no,
                category: this.category,
                range: this.range,
                onchol: this.onchol,
                start_date: moment(this.start_date).format("YYYY-MM-DD"),
                end_date: moment(this.end_date).format("YYYY-MM-DD")
            }).then(response => {
                this.complaint_graph = response.data;
                const labels = this.complaint_graph.labels;
                const data = this.complaint_graph.data;
                
                // Dynamically create the series
                const seriesData = Object.entries(data).map(([key, values]) => ({
                    name: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
                    data: values
                }));

                // Update reactive data
                this.series = seriesData;
                
                // Ensure Vue detects the chartOptions update
                this.chartOptions = {
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories: labels
                    }
                };
            })
            .catch(error => {
                console.error("Failed to fetch count:", error);
            });
        },

        fetchComplaintByCategory() {
            this.$store.dispatch("issue/fetchComplaintByCategoryGraph", {
                ward_no: this.ward_noTwo,
                onchol: this.oncholTwo,
                category: this.categoryTwo,
                start_date: moment(this.start_dateTwo).format("YYYY-MM-DD"),
                end_date: moment(this.end_dateTwo).format("YYYY-MM-DD")
            }).then(response => {
                this.complain_by_category_graph = response.data;
                const rawData = this.complain_by_category_graph;

                const categories = Object.keys(rawData).map(category =>
                    category.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
                );

                const totals = Object.values(rawData).map(entry => entry.total);
                const resolved = Object.values(rawData).map(entry => entry.resolved);
                const ratios = Object.values(rawData).map(entry => entry.ratio !== undefined ? (entry.ratio * 100) : 0);

                this.seriesForCategory = [
                    {
                        name: 'Total',
                        data: totals
                    },
                    {
                        name: 'Resolved',
                        data: resolved
                    }
                ];

                const tooltipWithRatio = (ratiosArray => {
                    return {
                        shared: true,
                        custom: ({ series, dataPointIndex, w }) => {
                        const total = series[0][dataPointIndex];
                        const resolved = series[1][dataPointIndex];
                        const ratio = ratiosArray[dataPointIndex];
                        const category = w.globals.labels[dataPointIndex];

                        return `
                            <div style="padding: 8px; font-size: 14px;">
                            <strong>${category}</strong><br/>
                            Total: ${total}<br/>
                            Resolved: ${resolved}<br/>
                            Resolution Ratio: ${ratio}%
                            </div>
                        `;
                        }
                    };
                })(ratios);

                this.chartOptionsForCategory = {
                    xaxis: {
                        categories: categories
                    },
                    tooltip: tooltipWithRatio
                }
            })
            .catch(error => {
                console.error("Failed to fetch count:", error);
            });
        },

        chartOptionsForOncholGraph() {
            this.$store.dispatch("issue/fetchComplaintByOncholGraph", {
                start_date: moment(this.start_dateThree).format("YYYY-MM-DD"),
                end_date: moment(this.end_dateThree).format("YYYY-MM-DD"),
                category: this.categoryThree
            }).then(response => {
                this.complain_by_onchol_graph = response.data;
                const oncholData = this.complain_by_onchol_graph;

                const categories_onchol = Object.keys(oncholData).map(category =>
                    category.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
                );

                const o_totals = Object.values(oncholData).map(entry => entry.total);
                const o_resolved = Object.values(oncholData).map(entry => entry.resolved);
                const o_ratios = Object.values(oncholData).map(entry => entry.resolved_ratio !== undefined ? (entry.resolved_ratio * 100) : 0);
                const o_average_resolution_days = Object.values(oncholData).map(entry => entry.average_resolution_days !== undefined ? entry.average_resolution_days : 0);

                this.seriesForOnchol = [
                    {
                        name: 'Total',
                        data: o_totals
                    },
                    {
                        name: 'Resolved',
                        data: o_resolved
                    }
                ];

                const tooltipWithRatioOnchol = {
                shared: true,
                    custom: ({ series, dataPointIndex, w }) => {
                        const o_total = series[0]?.[dataPointIndex] ?? 0;
                        const o_resolved = series[1]?.[dataPointIndex] ?? 0;
                        const o_ratio = o_ratios?.[dataPointIndex] ?? 0;
                        const o_avg_days = o_average_resolution_days?.[dataPointIndex] ?? 0;
                        const o_category = w.globals.labels[dataPointIndex] || '';

                        return `
                        <div style="padding: 8px; font-size: 14px;">
                            <strong>${o_category}</strong><br/>
                            Total: ${o_total}<br/>
                            Resolved: ${o_resolved}<br/>
                            Resolution Ratio: ${o_ratio}%<br/>
                            Avg. Resolution Day: ${o_avg_days}
                        </div>
                        `;
                    }
                };

                this.chartOptionsForOnchol = {
                    xaxis: {
                        categories: categories_onchol
                    },
                    tooltip: tooltipWithRatioOnchol
                }
            })
            .catch(error => {
                console.error("Failed to fetch count:", error);
            });
        },

        chartOptionsForWardGraph() {
            this.$store.dispatch("issue/fetchComplaintByWardGraph", {
                start_date: moment(this.start_dateFour).format("YYYY-MM-DD"),
                end_date: moment(this.end_dateFour).format("YYYY-MM-DD"),
                category: this.categoryFour
            }).then(response => {
                this.complain_by_ward_graph = response.data;
                const wardData = this.complain_by_ward_graph;

                const categories_ward = Object.keys(wardData).map(category =>
                    category.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
                );

                const w_totals = Object.values(wardData).map(entry => entry.total);
                const w_resolved = Object.values(wardData).map(entry => entry.resolved);
                const w_ratios = Object.values(wardData).map(entry => entry.resolved_ratio !== undefined ? (entry.resolved_ratio * 100) : 0);
                const w_average_resolution_days = Object.values(wardData).map(entry => entry.average_resolution_days !== undefined ? entry.average_resolution_days : 0);

                this.seriesForWard = [
                    {
                        name: 'Total',
                        data: w_totals
                    },
                    {
                        name: 'Resolved',
                        data: w_resolved
                    }
                ];

                const tooltipWithRatioWard = {
                shared: true,
                    custom: ({ series, dataPointIndex, w }) => {
                        const w_total = series[0]?.[dataPointIndex] ?? 0;
                        const w_resolved = series[1]?.[dataPointIndex] ?? 0;
                        const w_ratio = w_ratios?.[dataPointIndex] ?? 0;
                        const w_avg_days = w_average_resolution_days?.[dataPointIndex] ?? 0;
                        const w_category = w.globals.labels[dataPointIndex] || '';

                        return `
                        <div style="padding: 8px; font-size: 14px;">
                            <strong>${w_category}</strong><br/>
                            Total: ${w_total}<br/>
                            Resolved: ${w_resolved}<br/>
                            Resolution Ratio: ${w_ratio}%<br/>
                            Avg. Resolution Day: ${w_avg_days}
                        </div>
                        `;
                    }
                };

                this.chartOptionsForWard = {
                    xaxis: {
                        categories: categories_ward
                    },
                    tooltip: tooltipWithRatioWard
                }
            })
            .catch(error => {
                console.error("Failed to fetch count:", error);
            });
        },

        clearFilter() {
            this.onchol = null;
            this.category = null;
            this.ward_no = null;
            this.range = this.range,
            this.start_date = this.start_date,
            this.end_date = this.end_date
        },

        clearFilterTow() {
            this.oncholTwo = null;
            this.ward_noTwo = null;
            this.categoryTwo = null;
        },

        clearFilterThree() {
            this.categoryThree = null;
        },

        clearFilterFour() {
            this.categoryFour = null;
        },
    }
};
</script>

<style scoped>
@media print {
    #download-pdf, #download-pdf * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}

.margin-y-axis {
    margin-top: 16px;
    margin-bottom: 16px;
}

.margin-top {
    margin-top: 24px;
}

.margin-botton {
    margin-bottom: 16px;
}

.border-class {
    border-radius: 0.375rem;
}

.title {
    font-size: large;
    font-weight: 500;
    color: #00984a;
}

.count {
    text-align: end;
    font-size: xx-large;
    font-weight: 500;
    margin-top: -1px;
}

.main-title {
    font-size: x-large;
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large;
        font-weight: 500;
    }
}

@media (max-width: 767px) {
    .margin-top {
        margin-top: 0px;
    }
}

@media (min-width: 768px) {
    .margin-y-axis {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .margin-botton {
        margin-bottom: 0px;
    }
}
</style>
    